import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingCart, FiHeart, FiEye } from 'react-icons/fi';
import { useCartStore } from '../store/cartStore';
import { useWishlistStore } from '../store/wishlistStore';
import { useProductOverride } from '../context/ProductPriceContext';
import './ProductCard.css';

function ProductCard({ product: _product, simple }) {
  const [added, setAdded] = useState(false);
  const { addToCart, loading } = useCartStore();
  const { toggle, isLiked } = useWishlistStore();
  const override = useProductOverride(_product.id);
  const product = override ? { ..._product, ...override } : _product;
  const wishlisted = isLiked(product.id);

  const handleAddToCart = async (e) => {
    e.preventDefault();
    try {
      await addToCart(product.id, 1, product);
      setAdded(true);
      setTimeout(() => setAdded(false), 1400);
    } catch {}
  };

  const activeDiscount = product.discount_price && product.discount_active !== false ? product.discount_price : null;
  const discount = activeDiscount
    ? Math.round(((product.price - activeDiscount) / product.price) * 100)
    : 0;

  const displayPrice = activeDiscount || product.price;
  const isInactive = product.is_active === false;
  const inStock = product.stock > 0 && !isInactive;

  if (simple) return (
    <Link to={`/products/${product.id}`} className="simple-card">
      <div className="simple-card-img">
        {!inStock && <span className="simple-card-oos">Sold Out</span>}
        {discount > 0 && <span className="simple-card-badge">{discount}% OFF</span>}
        <img src={product.image_url || 'https://placehold.co/400x400?text=No+Image'} alt={product.name} />
      </div>
      <div className="simple-card-info">
        <p className="simple-card-name">{product.name}</p>
        {!isInactive && (
          <div className="simple-card-prices">
            <span className="simple-card-price">Rs.{displayPrice.toFixed(0)}</span>
            {activeDiscount && <span className="simple-card-orig">Rs.{product.price.toFixed(0)}</span>}
          </div>
        )}
      </div>
    </Link>
  );

  return (
    <Link to={`/products/${product.id}`} className={`product-card${!inStock ? ' out-of-stock-card' : ''}`}>

      {/* ── Image ── */}
      <div className="product-image-wrapper">
        <img
          src={product.image_url || 'https://placehold.co/400x400?text=No+Image'}
          alt={product.name}
          className="product-image"
        />

        {/* Gradient overlay (fades in on hover) */}
        <div className="product-img-overlay" />

        {/* Badges */}
        {discount > 0 && (
          <span className="discount-badge">{discount}% OFF</span>
        )}

        {/* Wishlist */}
        <button
          className={`wishlist-btn${wishlisted ? ' active' : ''}`}
          onClick={e => { e.preventDefault(); toggle(product); }}
          title={wishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
        >
          <FiHeart size={15} fill={wishlisted ? '#ef4444' : 'none'} />
        </button>

        {/* Hover action tray */}
        {inStock ? (
          <div className="product-action-tray">
            <button
              className={`tray-cart-btn${added ? ' added' : ''}`}
              onClick={handleAddToCart}
              disabled={loading}
            >
              <FiShoppingCart size={15} />
              {added ? 'Added!' : 'Add to Bag'}
            </button>
            <Link to={`/products/${product.id}`} className="tray-view-btn" onClick={e => e.stopPropagation()}>
              <FiEye size={15} />
            </Link>
          </div>
        ) : (
          <div className="product-oos-tray">
            <span>Out of Stock</span>
          </div>
        )}
      </div>

      {/* ── Info ── */}
      <div className="product-info">
        {/* Mobile-only cart button — sits above the title */}
        {inStock ? (
          <button
            className={`mobile-cart-btn${added ? ' added' : ''}`}
            onClick={handleAddToCart}
            disabled={loading}
          >
            <FiShoppingCart size={12} />
            {added ? 'Added!' : 'Add to Bag'}
          </button>
        ) : (
          <span className="mobile-oos-label">Out of Stock</span>
        )}

        <div className="product-info-top">
          {product.category?.name && (
            <span className="product-category">{product.category.name}</span>
          )}
          <h4 className="product-name">{product.name}</h4>
          <div className="product-rating">
            <span className="stars">
              {[1,2,3,4,5].map(n => (
                <span key={n} className={n <= Math.round(product.rating || 0) ? 'star filled' : 'star'}>★</span>
              ))}
            </span>
            <span className="reviews">({product.reviews_count || 0})</span>
          </div>
        </div>

        {!isInactive && (
          <div className="product-price-row">
            <div className="product-price">
              <span className="price-currency">Rs</span>
              <span className="price-amount">{displayPrice.toFixed(0)}</span>
              <span className="price-slash">/-</span>
            </div>
            {activeDiscount && (
              <span className="original-price">Rs {product.price.toFixed(0)}/-</span>
            )}
          </div>
        )}
      </div>

    </Link>
  );
}

export default ProductCard;
